import { LegacyVegreferanse } from '@/domain/LegacyVegreferanse';

const LEGACY_VEGREFERANSE_PATTERN =
    /^(\d{4})\s*([ERFKPS])\s*([VWTSGUBMXAHPEQ])\s*(\d+)\s*hp\s*(\d+)\s*m\s*(\d+)$/i;

export function parseLegacyVegreferanse(input: string): LegacyVegreferanse | null {
    const match = input.trim().match(LEGACY_VEGREFERANSE_PATTERN);
    if (!match) return null;

    const [, municipalityCode, kategori, status, vegnummer, hp, meter] = match;

    return new LegacyVegreferanse(
        Number(municipalityCode.slice(0, 2)),
        Number(municipalityCode.slice(2, 4)),
        kategori.toUpperCase(),
        status.toUpperCase(),
        Number(vegnummer),
        Number(hp),
        Number(meter),
        `${municipalityCode} ${kategori.toUpperCase()}${status.toUpperCase()}${Number(vegnummer)} hp${Number(
            hp
        )} m${Number(meter)}`
    );
}
